import axios from 'axios';

const API_URL = 'https://dev-api.thoorigai.net/api/v1/form';

const handleApiError = (error) => {
  if (error.response?.data) {
    return error.response.data;
  }
  return { success: false, message: 'An error occurred' };
};

export const getAllForms = async () => {
  try {
    const response = await axios({
      url: `${API_URL}/get-all-forms`,
      method: 'GET',
      withCredentials: true,
    });
    return response.data;
  } catch (error) {
    return handleApiError(error);
  }
};

export const getFormById = async (id) => {
  try {
    const response = await axios({
      url: `${API_URL}/get-form/${id}`,
      method: 'GET',
      withCredentials: true,
    });
    return response.data;
  } catch (error) {
    return handleApiError(error);
  }
};

export const getUserForms = async () => {
  try {
    const response = await axios({
      url: `${API_URL}/get-user-forms`,
      method: 'GET',
      withCredentials: true,
    });
    return response.data;
  } catch (error) {
    return handleApiError(error);
  }
};

export const createForm = async (formData) => {
  try {
    const response = await axios({
      url: `${API_URL}/create-form`,
      method: 'POST',
      data: formData,
      withCredentials: true,
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
    return response.data;
  } catch (error) {
    return handleApiError(error);
  }
};

export const updateForm = async (formData) => {
  try {
    const response = await axios({
      url: `${API_URL}/update-form`,
      method: 'PUT',
      data: formData,
      withCredentials: true,
    });
    return response.data;
  } catch (error) {
    return handleApiError(error);
  }
};

export const deleteForm = async (id) => {
  try {
    const response = await axios({
      url: `${API_URL}/delete-form/${id}`,
      method: 'DELETE',
      withCredentials: true,
    });
    return response.data;
  } catch (error) {
    return handleApiError(error);
  }
};

const formService = {
  getAllForms,
  getFormById,
  getUserForms,
  createForm,
  updateForm,
  deleteForm,
};

export default formService;
